import { render, staticRenderFns } from "./Wp_pdd_my_child_num_income.vue?vue&type=template&id=516b4320&scoped=true&"
import script from "./Wp_pdd_my_child_num_income.vue?vue&type=script&lang=js&"
export * from "./Wp_pdd_my_child_num_income.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516b4320",
  null
  
)

export default component.exports